export default __webpack_public_path__ + "static/realWorldImg3-9b7e413aea31f081f2fd0078c434c027.png";